import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { FaSpinner } from "react-icons/fa";
import config from "../../config";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";
import RichTextEditor from "../RichTextEditor";

const Restaurant = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [restaurant, setRestaurant] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [subCategory, setSubCategory] = useState([]);

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [filterStatus, setFilterStatus] = useState("");
  const [filterCity, setFilterCity] = useState("");
  const [allCities, setAllCities] = useState([]);

  // const [stateId, setStateId] = useState("");
  // const [cityId, setCityId] = useState("");

  const axiosAPI = useAxios();
  const BASE_URL = config?.apiBaseUrl;

  const [formData, setFormData] = useState({
    name: "",
    sub_category_id: "",
    phone_number: "",
    address: "",
    city: "",
    state: "",
    description: "",
    pincode: "",
    full_address: "",
    is_verified_by_call: "",
    is_verified_by_inspection: "",
    is_verified_by_visit: "",
    is_verified_by_menu: "",
    rating: "",
    timing: "",
    thumbnail_url: "",
    website_url: "",
    is_active_or_inactive_status: "",
    map_link: "",
    map_embed_url: "",

  });

  function removeFormData() {
    setFormData({
      name: "",
      sub_category_id: "",
      phone_number: "",
      address: "",
      country: "",
      city: "",
      state: "",
      description: "",
      pincode: "",
      full_address: "",
      is_verified_by_call: "",
      is_verified_by_inspection: "",
      is_verified_by_visit: "",
      is_verified_by_menu: "",
      rating: "",
      timing: "",
      thumbnail_url: "",
      website_url: "",
      is_active_or_inactive_status: "",
      map_link: "",
      map_embed_url: "",
      states: [],
      cities: [],
    });
  }

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  async function fetchRestaurant() {
    try {
      setLoading(true);
      let url = `/api/restaurant?page=${page}`;
      if (filterStatus) url += `&status=${filterStatus}`;
      if (filterCity) url += `&city=${filterCity}`;
      const response = await axiosAPI.get(url);
      setRestaurant(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      setRestaurant([]);
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  async function fetchSubCategory(id) {
    try {
      const response = await axiosAPI.get(`/api/v1/all-subcategories`);
      setSubCategory(response?.data?.subcategories);
    } catch (error) {
      console.error("Error fetching category:", error);

      setSubCategory([]);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    const payload = {
      name: formData.name,
      sub_category_id: formData.sub_category_id,
      phone_number: formData.phone_number,
      address: formData.address,
      country: formData.country,
      state: formData.state,
      description: formData.description,
      pincode: formData.pincode,
      city: formData.city,
      full_address: formData.full_address,
      is_verified_by_call: formData.is_verified_by_call,
      is_verified_by_inspection: formData.is_verified_by_inspection,
      is_verified_by_visit: formData.is_verified_by_visit,
      is_verified_by_menu: formData.is_verified_by_menu,
      rating: formData.rating,
      timing: formData.timing,
      thumbnail_url: formData.thumbnail_url,
      website_url: formData.website_url,

      map_link: formData.map_link,
      map_embed_url: formData.map_embed_url,
    };

    console.log("ratin", payload)
    try {
      let response;

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/restaurant/${currentUserId}`,
          payload
        );

        window.notifyMessage(
          "Success",
          "Restaurant details updated successfully",
          "success"
        );
      } else {
        response = await axiosAPI.post(`/api/restaurant`, payload);

        window.notifyMessage(
          "Success",
          "Restaurant details added successfully",
          "success"
        );
      }

      hideModal("newUserModal");
      removeFormData();
      fetchRestaurant(); // refresh list
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "There was an error!";
      window.notifyMessage("Error", errorMsg, "danger");
    } finally {
      setLoading(false); // Stop loading in all cases
    }
  };

  // console.log("restaurant", restaurant);
  const openEditModal = (restaurantId) => {
    setIsEditMode(true);
    showModal("newUserModal");
    setCurrentUserId(restaurantId);

    // Use a different variable name in the callback
    const productToEdit = restaurant.find(
      (restaurant) => restaurant.id === restaurantId
    );


    // setStateId(productToEdit?.state || "");
    // setCityId(productToEdit?.city || "");
    console.log("Id", productToEdit);

    setFormData((prev) => ({
      ...prev,
      name: productToEdit?.name || "",
      sub_category_id: productToEdit?.subcategory_id || "",
      phone_number: productToEdit?.phone_number || "",
      address: productToEdit?.address || "",
      country: productToEdit?.country || "",
      state: productToEdit?.state || "",
      description: productToEdit?.description || "",
      city: productToEdit?.city || "",
      pincode: productToEdit?.pincode || "",
      full_address: productToEdit?.full_address || "",
      is_verified_by_call: productToEdit?.is_verified_by_call || "",
      is_verified_by_inspection: productToEdit?.is_verified_by_inspection || "",
      is_verified_by_visit: productToEdit?.is_verified_by_visit || "",
      is_verified_by_menu: productToEdit?.is_verified_by_menu || "",
      rating: productToEdit?.rating || "",
      timing: productToEdit?.timing || "",
      thumbnail_url: productToEdit?.thumbnail_url || "",
      website_url: productToEdit?.website_url || "",
      // NEW
      map_link: productToEdit?.map_link || "",
      map_embed_url: productToEdit?.map_embed_url || "",
    }));

    // setStateId( "");
    // setCityId( "");
  };

  console.log("Form", formData)


  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/restaurant/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchRestaurant();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  async function changeRestaurantStatus(e, restaurantId) {
    const currentStatus = e.target.value;

    // console.log("product  Id", blogId);
    // console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the product card status?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/restaurant/change-restaurant-status/${restaurantId}`,
        { status: currentStatus }
      );

      fetchRestaurant();
      window.notifyMessage(
        "Success",
        "Restaurant status changed successfully",
        "success"
      );
    } catch (error) {
      console.error("Error changing product status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change restaurant status. Please try again.",
        "danger"
      );
    }
  }

  function openMediaLibraryModal() {
    showModal("customModal");
  }

  function handleMediaSumbit() {
    // console.log("Media Ids", formData.mediaIds);
    hideModal("customModal");
  }
  function openBlogModal() {
    showModal("newUserModal");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  useEffect(() => {
    fetchSubCategory();
  }, []);

  useEffect(() => {
    fetchRestaurant();
  }, [page, filterStatus, filterCity]);

  useEffect(() => {
    const fetchAllCities = async () => {
      try {
        const res = await axiosAPI.get("/api/restaurant/cities");
        if (res.data.success) {
          setAllCities(res.data.data);
        }
      } catch (err) {
        console.error("Error loading all cities:", err);
      }
    };
    fetchAllCities();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await axiosAPI.get("/api/restaurant/states");

        if (res.data.success) {
          // setFormData(prev => ({
          //   ...prev,
          //   states: res.data.data
          // }));
          setStates(res.data.data)
        }
      } catch (err) {
        console.error("Error loading states:", err);
      }
    };

    fetchStates();
  }, []);




  // Load cities when state changes
  useEffect(() => {
    if (!formData.state) return;

    const fetchCities = async () => {
      try {
        const res = await axiosAPI.get(`/api/restaurant/cities?stateId=${formData.state}`);

        if (res.data.success) {
          // setFormData(prev => ({
          //   ...prev,
          //   cities: res.data.data
          // }));
          setCities(res.data.data)
        }
      } catch (err) {
        console.error("Error loading cities:", err);
      }
    };

    fetchCities();
  }, [formData.state]);

  return (
    <div className="container">
      <div className="page-inner">

        <div className="d-flex justify-content-between align-items-center mb-4 flex-column flex-md-row">
          <div className="d-flex gap-3 mb-3 mb-md-0">
            <select
              className="form-select"
              value={filterStatus}
              onChange={(e) => {
                setFilterStatus(e.target.value);
                setPage(1);
              }}
            >
              <option value="">All Status</option>
              <option value="YES">Active (YES)</option>
              <option value="NO">Inactive (NO)</option>
            </select>
            <select
              className="form-select"
              value={filterCity}
              onChange={(e) => {
                setFilterCity(e.target.value);
                setPage(1);
              }}
            >
              <option value="">All Cities</option>
              {allCities.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round"
              onClick={() => openBlogModal()}
            >
              Add Restaurant
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Restaurant" : "Add Restaurant"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/*Restaurant Name */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Enter Restaurant name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="phone_number" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone_number"
                        placeholder="Enter Restaurant phone number"
                        value={formData.phone_number}
                        onChange={handleChange}
                      />
                    </div>
                  </div>


                  {/* Address
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      placeholder="Enter restaurant address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div> */}

                  {/* Full Address */}
                  <div className="mb-3">
                    <label htmlFor="full_address" className="form-label">
                      Full Address
                    </label>
                    <textarea
                      className="form-control"
                      id="full_address"
                      rows="3"
                      placeholder="Enter full address"
                      value={formData.full_address}
                      onChange={handleChange}
                    ></textarea>
                  </div>


                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      rows="3"
                      placeholder="Enter full description"
                      value={formData.description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {/* Pincode */}
                  <div className="mb-3">
                    <label htmlFor="pincode" className="form-label">
                      Pincode
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pincode"
                      placeholder="Enter pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                    />
                  </div>



                  {/* Country */}
                  <div className="row">

                    {/* Country */}
                    <div className="col-md-4 mb-3">
                      <label htmlFor="country" className="form-label">Country</label>
                      <select
                        className="form-select"
                        value={formData.country}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            country: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Country</option>
                        <option value="India">India</option>
                      </select>
                    </div>

                    {/* State */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label">State</label>
                      <select
                        className="form-select"
                        value={formData.state}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            state: e.target.value,
                            city: "",      // Clear city when state changes
                            cities: []     // Clear cities
                          }))
                        }
                      >
                        <option value="">Select State</option>
                        {states?.map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </select>

                    </div>

                    {/* City */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label">City</label>
                      <select
                        className="form-select"
                        value={formData.city}
                        disabled={!formData.state}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            city: e.target.value
                          }))
                        }
                      >
                        <option value="">Select City</option>
                        {cities.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                      </select>

                    </div>

                  </div>





                  {/* Verified by call */}

                  <div className="row">

                    {/* Verified by Call */}
                    <div className="col-md-3 mb-3">
                      <label htmlFor="is_verified_by_call" className="form-label">
                        Is Verified By Call
                      </label>
                      <select
                        className="form-select"
                        id="is_verified_by_call"
                        value={formData.is_verified_by_call}
                        onChange={handleChange}
                      >
                        <option value="NO">No</option>
                        <option value="YES">Yes</option>
                      </select>
                    </div>

                    {/* Verified by Inspection */}
                    <div className="col-md-3 mb-3">
                      <label htmlFor="is_verified_by_inspection" className="form-label">
                        Is Verified By Inspection
                      </label>
                      <select
                        className="form-select"
                        id="is_verified_by_inspection"
                        value={formData.is_verified_by_inspection}
                        onChange={handleChange}
                      >
                        <option value="NO">No</option>
                        <option value="YES">Yes</option>
                      </select>
                    </div>

                    {/* Verified by Visit */}
                    <div className="col-md-3 mb-3">
                      <label htmlFor="is_verified_by_visit" className="form-label">
                        Is Verified By Visit
                      </label>
                      <select
                        className="form-select"
                        id="is_verified_by_visit"
                        value={formData.is_verified_by_visit}
                        onChange={handleChange}
                      >
                        <option value="NO">No</option>
                        <option value="YES">Yes</option>
                      </select>
                    </div>

                    {/* is_verified_by_menu */}
                    <div className="col-md-3 mb-3">
                      <label htmlFor="is_verified_by_menu" className="form-label">
                        Is Verified By Menu
                      </label>
                      <select
                        className="form-select"
                        id="is_verified_by_menu"
                        value={formData.is_verified_by_menu}
                        onChange={handleChange}
                      >
                        <option value="NO">No</option>
                        <option value="YES">Yes</option>
                      </select>
                    </div>

                  </div>

                  <div className="row">
                    {/* Rating */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="rating" className="form-label">Rating</label>
                      <input
                        type="text"
                        className="form-control"
                        id="rating"
                        placeholder="Enter Rating"
                        value={formData.rating}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Timing */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="timing" className="form-label">Timing</label>
                      <input
                        type="text"
                        className="form-control"
                        id="timing"
                        placeholder="Enter timing"
                        value={formData.timing}
                        onChange={handleChange}
                      />
                    </div>


                    {/* Thumbnail Url */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="thumbnail_url" className="form-label">Thumbnail Url</label>
                      <input
                        type="text"
                        className="form-control"
                        id="thumbnail_url"
                        placeholder="Enter thumbnail url"
                        value={formData.thumbnail_url}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Map Link */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="map_link" className="form-label">Google Map Link</label>
                      <input
                        type="text"
                        className="form-control"
                        id="map_link"
                        placeholder="https://maps.google.com/..."
                        value={formData.map_link}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Map Embed URL */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="map_embed_url" className="form-label">Map Embed URL</label>
                      <input
                        type="text"
                        className="form-control"
                        id="map_embed_url"
                        placeholder="https://www.google.com/maps/embed?..."
                        value={formData.map_embed_url}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Website Url */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="website_url" className="form-label">Website Url</label>
                      <input
                        type="text"
                        className="form-control"
                        id="website_url"
                        placeholder="https://www.example.com"
                        value={formData.website_url}
                        onChange={handleChange}
                      />
                    </div>

                  </div>



                  {/* Ratingg*/}







                  {/* Sub Category Id
                  <div className="mb-3">
                    <label htmlFor="sub_category_id" className="form-label">
                      Sub Category
                    </label>
                    <select
                      className="form-select"
                      id="sub_category_id"
                      value={formData.sub_category_id}
                      onChange={handleChange}
                    >
                      <option value="">Select Sub Category</option>
                      {subCategory &&
                        subCategory?.map((subCategory) => (
                          <option key={subCategory?.id} value={subCategory?.id}>
                            {subCategory?.name}
                          </option>
                        ))}
                    </select>
                  </div> */}

                  <button
                    type="submit"
                    className="btn btn-primary  btn-sm"
                    disabled={loading}
                  >
                    {loading ? (
                      <FaSpinner className="spinner" spin />
                    ) : isEditMode ? (
                      "Update Restaurant"
                    ) : (
                      "Add Restaurant"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* restaurant Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Restaurants ({restaurant?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr no</th>
                        <th>Name</th>
                        <th>Phone Number</th>
                        <th>Sub Category</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : restaurant?.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No restaurants found.
                          </td>
                        </tr>
                      ) : (
                        restaurant &&
                        restaurant?.map((restaurant, index) => (
                          <tr key={restaurant.id}>
                            <td>{index + 1}</td>
                            <td>{restaurant?.name}</td>
                            <td>{restaurant?.phone_number}</td>
                            <td>{restaurant?.subcategory_id}</td>

                            <td>
                              <select
                                className="form-select"
                                value={restaurant.is_active_or_inactive || restaurant.is_active_or_inactive_status}
                                onChange={(e) =>
                                  changeRestaurantStatus(e, restaurant?.id)
                                }
                              >
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                              </select>
                            </td>
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() => openEditModal(restaurant.id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(restaurant.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Restaurant;
